enum Action {
  AddFile,
  UpdateFile,
  RemoveFile,
}

export default Action;
